import React from 'react';
import { Pressable, StyleSheet } from 'react-native';

import { Text } from '@/components/TextComponent';
import { common } from '@/styles/styles';

import { ds } from './lib/design.system';

type FilterChipProps = {
    label: string;
    active: boolean;
    onPress: () => void;
    testID?: string;
};

/**
 * Pill-shaped single-select filter chip (Figma 13444-65104). Distinct from `ChipButton`, whose
 * rounded-rect shape and active color differ.
 */
export const FilterChip = ({ label, active, onPress, testID }: FilterChipProps) => (
    <Pressable
        onPress={onPress}
        style={[styles.chip, active ? styles.chipActive : styles.chipInactive, common.borderCurve]}
    >
        <Text
            variant="labelLarge"
            letterSpacing={-0.08}
            color={active ? ds.colorToken.text.primary : 'neutral300'}
            testID={testID}
        >
            {label}
        </Text>
    </Pressable>
);

const styles = StyleSheet.create({
    chip: {
        borderRadius: 100,
        paddingHorizontal: 16,
        paddingVertical: 8,
        borderWidth: 1,
        borderColor: ds.colorValue.border.subtle,
        alignItems: 'center',
        justifyContent: 'center',
    },
    chipActive: {
        backgroundColor: ds.colorValue.background.neutral.subtle,
    },
    chipInactive: {
        backgroundColor: ds.colorValue.background.neutral.subtler,
    },
});
